angular.module('jv.onboarding.controller', [])
    .controller('jvOnboardingController', [
        '$scope', '$rootScope','$filter','jvCandidatesService','TemplateLoader','jvNotesFactory','candidates',
        function($scope, $rootScope,$filter,jvCandidatesService,TemplateLoader,jvNotesFactory, candidates) {
        	$scope.moveToOnBoarding = {};
        	$scope.appDetails = {};
        	$scope.modal.showOnboardingModal = false;
        	$scope.templates = TemplateLoader.register({
        		sendToOnboarding: '/jhire/modules/candidates/modals/moveToOnBoarding.html'
            });
        	$scope.initData = function(onbordingEvent) {
        		TemplateLoader.load('sendToOnboarding').then(function(){
        			$scope.showOnboardingModal(onbordingEvent);
        		});
            };
        	
            $scope.hideModals = function(){
            	$scope.modal.showOnboardingModal = false;
            }
            $rootScope.$on('showSendToOnboardingModal',function(event,data){
            	if(data) {
            		$scope.applicationEId = data.applicationEId;
                	$scope.workflowStateEId = data.workflowStateId;
                	$scope.appDetails = data.appDetails;
                	$scope.isGeneralApplication = false;
                    $scope.isHiringManagerAbsent = false;
                	if (!data.appDetails?.application?.job || data.appDetails.application.job.title === 'General Application') {
                        $scope.isGeneralApplication = true;
                    }
                    else if (!data.appDetails?.primaryHiringManagerName || !data.appDetails?.primaryHiringManagerEmail) {
                        $scope.isHiringManagerAbsent = true;
                    }
                	if(data.onBoardingEvent === 'send') {
                		$scope.validateAndMoveToOnboarding(data.onBoardingEvent);
                	} else {
                		$scope.initData(data.onBoardingEvent);
                	}
            	}
            });
            
            $rootScope.$on('showStopOnboardingModal',function(event,data){
            	if(data) {
            		$scope.applicationEId = data.applicationEId;
                	$scope.workflowStateEId = data.workflowStateId;
                	$scope.appDetails = data.appDetails;
                	$scope.newHireId = data.jobviteOnboardingStatus.newHireId;
                	$scope.initData('stop');
            	}
            });
            
            /*
             * Opens up the note flyout with the orchestrator's name pre-filled in when
             * "Message Orchestrator" action is clicked from workflow tab.
             */
            $rootScope.$on('messageOrchestrator',function(event,jobviteOnboardingStatus){
            	if(jobviteOnboardingStatus && jobviteOnboardingStatus.orchestratorUserEId) {
            		candidates.getEmployee(jobviteOnboardingStatus.orchestratorUserEId, function(res) {
            			if(res && res.employees) {
            				var user = res.employees[0];
            				var noteObj = {};
            				noteObj.to = [user];
            				noteObj.subject = "";
            				noteObj.content = "";
            				jvNotesFactory.openFlyout(noteObj);
            			}
            		});
            	}
            });
            
	        $scope.showOnboardingModal = function(onboardingEvent) {
	        	$scope.modal.showOnboardingModal = true;
	        	if(onboardingEvent === 'send') {
	        		$scope.moveToOnBoarding.title = i18n.CONFIRM_JV_ONBOARDING;
		        	$scope.moveToOnBoarding.button = i18n.SEND_TO_JV_ONBOARDING;
		        	$scope.moveToOnBoarding.modal = "send_to_onboarding";
	        	} if(onboardingEvent === 'start') {
	        		$scope.moveToOnBoarding.title = i18n.CONFIRM_JV_ONBOARDING;
		        	$scope.moveToOnBoarding.button = i18n.PUSHTOJOBVITEBOARDING;
		        	$scope.moveToOnBoarding.modal = "send_to_onboarding";
	        	} else if(onboardingEvent === 'stop') {
	        		$scope.modals.showOnboardingModal = true;
		        	$scope.moveToOnBoarding.title = i18n.CONFIRM_STOP_JV_ONBOARDING;
		        	$scope.moveToOnBoarding.button = i18n.STOP_JV_ONBOARDING;
		        	$scope.moveToOnBoarding.modal = "stop_onboarding";
	        	}
	        	
	        };
	        
	        $scope.moveToOnBoarding.send = function() {
	        	if($scope.moveToOnBoarding.modal == "send_to_onboarding") {
	        		$scope.sendToOnBoarding();
	        	} else if($scope.moveToOnBoarding.modal == "stop_onboarding") {
	        		$scope.retractJobviteOnboarding();
	        	}
	        };
	        
	        $scope.sendToOnBoarding = function() {
	        	var args = {};
	        	args.applicationEId = $scope.applicationEId;
	        	args.workflowStateEId = $scope.workflowStateEId;
	        	$scope.flags.loading = true;
	        	jvCandidatesService.sendToOnboarding(args, function(res) {
	        		$scope.flags.loading = false;
	        		$scope.modal.showOnboardingModal = false;
	        		if (res.data.onboardingAddNewHireResponse) {
	        			var result = res.data.onboardingAddNewHireResponse;
	        			if(result.status) {
	        				if(result.status === "CREATED") {
	        					$scope.updateWorkflowActions();
	        					$scope.showMsg('ONBOARDING_NEW_HIRE_' + result.status);
	        				} else {
	        					//ERROR_FIRST_NAME_MISSING,
	        					//ERROR_LAST_NAME_MISSING,
	        					//ERROR_EMAIL_MISSING
	        					$scope.showMsg('ONBOARDING_ERROR_REQUIRED_FIELD_MISSING', false, 'error');
	        				}
	        			}else if(result == 'MISSING_CANDIDATE_NAME_EMAIL'){
	        			        $rootScope.noticeTimeout = 8000;
                                $scope.showMsg('ONBOARDING_NEW_HIRE_' + result);
                        }
	        			else if(result == 'SENT_TO_ONBOARDED'){
	        			       $rootScope.noticeTimeout = 8000;
                               $scope.showMsg('ONBOARDING_NEW_HIRE_' + result);
                        }
	        		} else if(res.data.msgInfo == 400) {
	        			$rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION
	        		}
	        	});
	        };
	        
	        $scope.validateAndMoveToOnboarding = function(onBoardingEvent) {
	        	var args = {};
	        	args.applicationEId = $scope.applicationEId;
	        	args.workflowStateEId = $scope.workflowStateEId;
	        	if(enabledOnboardedIntegration === "true"){
	        	    $scope.initData(onBoardingEvent);
	        	}else{
	        	    $scope.flags.loading = true;
                    jvCandidatesService.getOnboardingStatus(args, function(res) {
                        $scope.flags.loading = false;
                        var valid = true;
                        if(res.data) {
                            if (res.data.jobviteOnboardingStatus) {
                                var result = res.data.jobviteOnboardingStatus;
                                if(result.status) {
                                    if(result.status != "NOTHING_STARTED") {
                                        valid = false;
                                        var notificationMessage = i18n.notices['ONBOARDING_CANDIDATE_OB_EXIST'];
                                        if(result.dateCreated) {
                                            var dateOBCreated = $filter('localeDateTime')(result.dateCreated, 'shortDate', 'MM/dd/yyyy');
                                            notificationMessage = notificationMessage.format(dateOBCreated);
                                        }
                                        $scope.showMsg(notificationMessage, true, 'notice');
                                        $scope.updateWorkflowActions();
                                    }
                                }
                            } else if(res.data.msgInfo == 400) {
                                valid = false;
                                $rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION
                            }
                        }
                        if(valid) {
                            $scope.initData(onBoardingEvent);
                        }
                    });
	        	}
	        };
	        
	        $scope.retractJobviteOnboarding = function() {
	        	var args = {};
	        	args.applicationEId = $scope.applicationEId;
	        	args.workflowStateEId = $scope.workflowStateEId;
	        	args.newHireId = $scope.newHireId;
	        	$scope.flags.loading = true;
	            jvCandidatesService.retractJobviteOnboarding(args, function(res) {
	                $scope.flags.loading = false;
	                $scope.modal.showOnboardingModal = false;
	                if(res.data.onboardingRetractNewHireResponse) {
	                	$scope.updateWorkflowActions();
	                	$scope.showMsg('JV_ONBOARDING_' + res.data.onboardingRetractNewHireResponse);
	                } else if(res.data.msgInfo == 400) {
	        			$rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION
	        		}
	                
	            }, function(err) {
	                //console.log('err : '+err);
	            });
	        };
       }
])